// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus-line-left';

export const Component = () => (
  <path d='M7.855 14.781v.958H0V3h.958v11.781h6.897Zm10.775.958v5.89h-.957v-5.89h-5.891v-.958h5.89v-5.89h.958v5.89h5.891v.958h-5.89Z' />
);

export const viewBox = '0 0 25 25';
